
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum LedgerPostType {
	Invoice = 0,
	CreditMemo = 1,
	MigratedInvoice = 2,
	CounterPost = 3,
	SettlementInvoice = 4,
	StartupInvoice = 5,
	EqualizingCounterPost = 6
}
export namespace LedgerPostType {
	export function getKeys(): Map<LedgerPostType, string> {
		return new Map([[0, 'Invoice'], [1, 'CreditMemo'], [2, 'MigratedInvoice'], [3, 'CounterPost'], [4, 'SettlementInvoice'], [5, 'StartupInvoice'], [6, 'EqualizingCounterPost']]);
	}
}
